<check-box 
           [view]="queryView"
           [triState]="true"
           (onValueChange)="notifyValueChange($event)">
</check-box>
